import { render, staticRenderFns } from "./ThemeSwitcher.vue?vue&type=template&id=dfa46f4e&"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ThemeSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports